// src/surveysAdmin/index.js — 📋 Surveys (Phase D3c): the managers-app builder
// + results board. ToyTalk "Feedback" replacement, oversight surface.
//
// HEAD OFFICE builds (title/intro/deadline; questions: choice / yes-no /
// rating / text; audience all / country / stores / INDIVIDUAL staff) and
// archives; results = per-question counts + average-rating bars + NAMED text
// answers, plus the completion board (% per store + who's missing). AMs see
// completion only (the Worker enforces it — this bundle just doesn't render
// what it never receives). Auth = the admin Bearer.

import { loadList } from '../shared/load-failure.js';   // v131.76 - say WHY a list is empty

import { areaChipsHtml, pickAreaStores } from '../shared/areaPick.js';
// v129.116 — reference files on a survey (Matt, 13 Aug: "can we get the option
// to do an attachment on a survey?"). Surveys were the one composing surface
// with none; this reuses the picker news and tasks got in v129.113.
import { MAX_COMPOSE_FILES, addAttachmentFiles, composeChipsHtml, attachLinksHtml, openFromPayload, wireDropZone, paintFileState, refusedSendOk } from '../shared/attachments-ui.js';
// v130.40 - the option cap comes from the Worker's pure survey core (the same
// dependency-free import achievementsAdmin makes for BADGES), so the hint in
// the composer and the rule that rejects the survey can never drift apart.
import { MAX_CHOICE_OPTIONS } from '../worker/surveys.js';

function esc(s) {
  return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function api(path, opts) {
  opts = opts || {};
  var base = (typeof DB !== 'undefined' && DB.workerUrl) ? DB.workerUrl() : '';
  var headers = { 'Content-Type': 'application/json' };
  var tk = (typeof DB !== 'undefined' && DB.getToken) ? DB.getToken() : null;
  if (tk) headers['Authorization'] = 'Bearer ' + tk;
  return fetch(base + path, { method: opts.method || 'GET', headers: headers, body: opts.body, cache: 'no-store' });
}
function toast(msg, kind) {
  if (typeof showToast !== 'undefined') showToast(msg, kind || 'success');
}

var _surveys = [];
var _isHO = false;
var _qRows = 1;            // builder question-row counter
var _openResults = null;

function root() { return document.getElementById('surveysAdminRoot'); }

var _styled = false;
function ensureStyles() {
  if (_styled) return;
  _styled = true;
  var css = '' +
    '#surveysAdminRoot .sa-wrap{max-width:760px}' +
    '#surveysAdminRoot .sa-compose{background:var(--card);border:1px solid var(--border);border-radius:12px;padding:16px;margin-bottom:16px}' +
    '#surveysAdminRoot .sa-compose h3{margin:0 0 10px;font-size:15px;color:var(--brand,#009E3D)}' +
    '#surveysAdminRoot .sa-in{width:100%;padding:9px 10px;border:1px solid var(--border-strong);border-radius:8px;font-size:13.5px;margin-bottom:8px;box-sizing:border-box;font-family:inherit}' +
    '#surveysAdminRoot .sa-row{display:flex;gap:10px;align-items:center;flex-wrap:wrap;margin-bottom:8px;font-size:13px}' +
    '#surveysAdminRoot .sa-list{max-height:160px;overflow-y:auto;border:1px solid var(--border);border-radius:8px;padding:8px;font-size:12.5px;columns:2;margin-bottom:8px}' +
    '#surveysAdminRoot .sa-q{border:1px dashed var(--border-strong);border-radius:8px;padding:10px;margin-bottom:8px}' +
    '#surveysAdminRoot .sa-go{background:var(--brand,#009E3D);color:#fff;border:none;border-radius:8px;padding:10px 18px;font-weight:700;font-size:13.5px;cursor:pointer}' +
    '#surveysAdminRoot .sa-btn{background:var(--bg,#f0f2f5);border:none;border-radius:8px;padding:6px 12px;font-size:12.5px;font-weight:600;cursor:pointer;color:var(--text,#111b21);margin-top:8px;margin-inline-end:6px}' +
    '#surveysAdminRoot .sa-card{background:var(--card);border:1px solid var(--border);border-radius:10px;padding:12px 14px;margin-bottom:10px}' +
    '#surveysAdminRoot .sa-title{font-weight:700;font-size:14.5px;color:var(--text,#111b21);display:flex;gap:6px;align-items:center;flex-wrap:wrap}' +
    '#surveysAdminRoot .sa-arch{font-size:10px;font-weight:800;background:var(--surface-3);color:var(--sub,#546e7a);border-radius:8px;padding:1px 7px}' +
    '#surveysAdminRoot .sa-meta{font-size:11.5px;color:var(--tiny,#8696a0);margin-top:4px}' +
    '#surveysAdminRoot .sa-bar{height:8px;border-radius:4px;background:var(--surface-3);overflow:hidden;margin:4px 0 8px}' +
    '#surveysAdminRoot .sa-fill{height:100%;background:var(--brand,#009E3D)}' +
    '#surveysAdminRoot .sa-res{margin-top:10px;border-top:1px solid var(--bg,#f0f2f5);padding-top:10px;font-size:12.5px}' +
    '#surveysAdminRoot .sa-names{font-size:11.5px;color:var(--sub,#546e7a);margin-top:2px}';
  var el = document.createElement('style');
  el.id = 'surveysAdminStyles';
  el.textContent = css;
  document.head.appendChild(el);
}

function storeOptions() {
  var names = [];
  try {
    if (typeof ALL_STORES !== 'undefined' && Array.isArray(ALL_STORES)) {
      names = ALL_STORES.map(function (s) { return typeof s === 'string' ? s : (s && s.name); }).filter(Boolean);
    }
  } catch (e) { /* hidden */ }
  return names;
}
function countryOptions() {
  var out = [];
  try {
    if (typeof getStoreCountry === 'function') {
      storeOptions().forEach(function (n) {
        var c = getStoreCountry(n);
        if (c && out.indexOf(c) === -1) out.push(c);
      });
    }
  } catch (e) { /* hidden */ }
  return out.sort();
}
// The ACTIVE staff roster for individual targeting — admin.html's staffData
// global (kept inline by the wave-2 breakup), typeof-guarded.
function staffOptions() {
  var out = [];
  try {
    if (typeof staffData !== 'undefined' && Array.isArray(staffData)) {
      staffData.forEach(function (s) {
        if (s && s.id != null && s.active !== false) out.push({ id: s.id, name: s.name || ('#' + s.id), store: s.store || '' });
      });
    }
  } catch (e) { /* hidden */ }
  return out.sort(function (a, b) { return String(a.store).localeCompare(String(b.store)) || String(a.name).localeCompare(String(b.name)); });
}

function render() {
  ensureStyles();
  var acct = (typeof currentAdmin !== 'undefined' && currentAdmin) ? currentAdmin : null;
  _isHO = !!(acct && String(acct.role).toLowerCase() === 'admin');
  paint();
  refresh();
}

// v131.76 - a failed load must not render as an empty list. See
// src/shared/load-failure.js for the incident this comes from.
var _loadError = null;
async function refresh() {
  var r = await loadList(api, '/api/admin/surveys', 'surveys');
  if (!r.ok) { _loadError = r.message; paintList(); return; }
  _loadError = null;
  _surveys = r.data.surveys || [];
  paintList();
}

function questionRowHtml(n) {
  return '<div class="sa-q" id="saQ' + n + '">' +
    '<div class="sa-row">Q' + n + ': <select id="saQt' + n + '" class="sa-in" style="width:auto;margin:0">' +
    '<option value="choice">Multiple choice</option><option value="yesno">Yes / No</option>' +
    '<option value="rating">Rating 1–5</option><option value="text">Free text</option></select>' +
    '<label style="margin-inline-start:auto"><input type="checkbox" id="saQr' + n + '" checked> Required</label></div>' +
    '<input id="saQl' + n + '" class="sa-in" maxlength="300" placeholder="Question wording">' +
    '<input id="saQo' + n + '" class="sa-in" placeholder="Options, comma-separated (multiple choice only, 2 to ' + MAX_CHOICE_OPTIONS + ')">' +
    '</div>';
}

function paint() {
  var el = root(); if (!el) return;
  var staffList = staffOptions();
  var compose = !_isHO ? '' :
    '<div class="sa-compose"><h3>📋 New survey</h3>' +
    '<input id="saTitle" class="sa-in" maxlength="200" placeholder="Survey title">' +
    '<textarea id="saIntro" class="sa-in" maxlength="2000" placeholder="Intro (optional)"></textarea>' +
    '<div class="sa-row">Deadline: <input type="date" id="saDeadline" class="sa-in" style="width:auto;margin:0"></div>' +
    '<div id="saQs">' + questionRowHtml(1) + '</div>' +
    '<button class="sa-btn" onclick="SurveysAdmin.addQuestion()">＋ Add question</button>' +
    '<div class="sa-row" style="margin-top:10px">' +
    '<label><input type="radio" name="saAud" value="all" checked onchange="SurveysAdmin.audChanged()"> Everyone</label>' +
    (countryOptions().length ? '<label><input type="radio" name="saAud" value="country" onchange="SurveysAdmin.audChanged()"> Country</label>' : '') +
    '<label><input type="radio" name="saAud" value="stores" onchange="SurveysAdmin.audChanged()"> Stores</label>' +
    (staffList.length ? '<label><input type="radio" name="saAud" value="staff" onchange="SurveysAdmin.audChanged()"> Individual people</label>' : '') +
    '</div>' +
    '<div id="saCountries" class="sa-row" style="display:none">' +
    countryOptions().map(function (c) { return '<label><input type="checkbox" class="saCountryCb" value="' + esc(c) + '"> ' + esc(c) + '</label>'; }).join('') + '</div>' +
    '<div id="saStores" class="sa-list" style="display:none">' +
    areaChipsHtml('SurveysAdmin') +
    storeOptions().map(function (n) { return '<label style="display:block"><input type="checkbox" class="saStoreCb" value="' + esc(n) + '"> ' + esc(n) + '</label>'; }).join('') + '</div>' +
    '<div id="saStaff" class="sa-list" style="display:none">' +
    staffList.map(function (s) { return '<label style="display:block"><input type="checkbox" class="saStaffCb" value="' + s.id + '"> <span translate="no">' + esc(s.name) + '</span> <span style="color:var(--tiny,#8696a0)">(' + esc(s.store) + ')</span></label>'; }).join('') + '</div>' +
    // v129.116 — attach reference files (a planogram, a price list, the procedure
    // being asked about). Same cap and allow-list as news/tasks.
    '<div class="sa-row">\u{1F4CE} Attach files (optional, up to ' + MAX_COMPOSE_FILES + '): ' +
    '<input type="file" id="saFile" multiple accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt" onchange="SurveysAdmin.attachPicked(this)" style="font-size:12px">' +
    '<span id="saFileState" style="font-size:11.5px;color:var(--tiny,#8696a0)">or drag them in</span>' +
    '<div id="saFileChips" style="flex-basis:100%">' + composeChipsHtml(_attachments, 'SurveysAdmin.attachRemove') + '</div></div>' +
    '<button class="sa-go" id="saGo" onclick="SurveysAdmin.publish()">Send survey</button></div>';
  // v126.71 — a search box over the list (Head Office). It lives OUTSIDE #saList so
  // re-rendering the list on each keystroke never steals its focus; paintList()
  // shows it once surveys have loaded.
  el.innerHTML = '<div class="sa-wrap">' + compose +
    '<div id="saSearchBar" style="margin:0 0 10px;display:none"><input id="saSearch" oninput="SurveysAdmin.onSearch(this.value)" placeholder="🔍 Search surveys…" style="width:100%;max-width:360px;padding:8px 12px;border:1px solid var(--border-strong);border-radius:8px;font-size:13px;box-sizing:border-box"></div>' +
    '<div id="saList"><div style="padding:24px;color:var(--tiny,#8696a0);font-size:13.5px">Loading…</div></div></div>';
  // v129.118 (Head Office) — drag files onto the composer, wired once on the
  // PERSISTENT root (paint() replaces innerHTML on every re-render).
  wireDropZone(el, { boxSelector: '.sa-compose', onFiles: function (files) { ingestDropped(files); } });
  paintList();
}

var _q = '';   // v126.71 — admin survey-list search
function matchesQ(s) {
  var q = _q.trim().toLowerCase();
  if (!q) return true;
  return ((String(s.title || '') + ' ' + String(s.intro || '')).toLowerCase().indexOf(q) !== -1);
}
function onSearch(v) { _q = String(v == null ? '' : v); paintList(); }

function paintList() {
  var slot = document.getElementById('saList');
  if (!slot) return;
  var bar = document.getElementById('saSearchBar');
  if (bar) bar.style.display = _surveys.length ? '' : 'none';
  var cards = _surveys.filter(matchesQ).map(function (s) {
    // v126.64 — show the survey's INTRO and the actual QUESTIONS, not just a
    // count. Same class of gap as the admin task/news cards: HO could see a
    // title and "3 question(s)" but not read WHAT was asked. Both are in the
    // data (shapeSurvey returns intro + questions), just never rendered. A
    // choice question also lists its options. All escaped — a label is data.
    var qType = { choice: '◉', yesno: '✓/✗', text: '✎', rating: '★' };
    var saIntro = s.intro
      ? '<div style="font-size:13px;color:var(--adm-comms-body);line-height:1.5;white-space:pre-wrap;word-break:break-word;margin:4px 0 6px">' + esc(s.intro) + '</div>'
      : '';
    var saQs = (s.questions || []).length
      ? '<div style="margin:4px 0 8px">' + (s.questions || []).map(function (q, qi) {
          var opts = (q.type === 'choice' && Array.isArray(q.options) && q.options.length)
            ? '<div translate="no" style="font-size:11.5px;color:var(--adm-comms-muted);margin-inline-start:20px">' + q.options.map(esc).join(' · ') + '</div>' : '';
          return '<div style="font-size:12.5px;color:var(--adm-comms-body);margin-top:3px"><b>' + (qi + 1) + '.</b> <span translate="no">' +
            esc(q.label || '') + '</span> <span style="color:var(--adm-comms-muted)">' + (qType[q.type] || esc(q.type || '')) + '</span></div>' + opts;
        }).join('') + '</div>'
      : '';
    return '<div class="sa-card">' +
      '<div class="sa-title">' + (s.archived ? '<span class="sa-arch">ARCHIVED</span>' : '') + '<span translate="no">' + esc(s.title) + '</span></div>' +
      '<div translate="no">' + saIntro + '</div>' +   // v135.2: Head Office's words, never the catalogue's
      '<div class="sa-meta"><span>Deadline ' + esc(s.deadline) + '</span> · <span>' + (s.questions || []).length + ' question(s)</span> · <span translate="no">' + esc(s.created_by || '') + '</span></div>' +
      attachLinksHtml(s, 'SurveysAdmin.openAttachment', { className: 'sa-meta' }) +
      saQs +
      '<button class="sa-btn" onclick="SurveysAdmin.toggleResults(' + s.id + ')">📊 Results</button>' +
      (_isHO ? '<button class="sa-btn" onclick="SurveysAdmin.archive(' + s.id + ',' + (s.archived ? 'false' : 'true') + ')">' + (s.archived ? '↩ Restore' : '🗄 Archive') + '</button>' : '') +
      '<div id="saRes' + s.id + '"></div></div>';
  }).join('');
  slot.innerHTML = cards || '<div style="padding:24px;color:var(--tiny,#8696a0);font-size:13.5px">' +
    (_loadError ? esc(_loadError) : (_q.trim() ? 'No surveys match "' + esc(_q.trim()) + '".' : 'No surveys yet.')) + '</div>';
}

function addQuestion() {
  _qRows++;
  var box = document.getElementById('saQs');
  if (box) box.insertAdjacentHTML('beforeend', questionRowHtml(_qRows));
}

function audChanged() {
  var v = document.querySelector('input[name="saAud"]:checked');
  var val = v ? v.value : 'all';
  var show = function (id, on) { var e = document.getElementById(id); if (e) e.style.display = on ? '' : 'none'; };
  show('saCountries', val === 'country');
  show('saStores', val === 'stores');
  show('saStaff', val === 'staff');
}

function collectQuestions() {
  var out = [];
  for (var n = 1; n <= _qRows; n++) {
    var label = (document.getElementById('saQl' + n) || {}).value || '';
    if (!String(label).trim()) continue;   // blank rows are skipped
    var type = (document.getElementById('saQt' + n) || {}).value || 'text';
    var q = { label: String(label).trim(), type: type, required: !!(document.getElementById('saQr' + n) || {}).checked };
    if (type === 'choice') {
      q.options = String((document.getElementById('saQo' + n) || {}).value || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }
    out.push(q);
  }
  return out;
}

// v129.116 — the picked files. They ACCUMULATE across picks and the chip row
// repaints ALONE, so adding a second file never wipes a half-written survey
// (the questions are the expensive part to re-type).
var _attachments = [];
var _refused = null;   // v136.71: what the last pick refused, until a later pick replaces it
function paintAttachChips() {
  var box = document.getElementById('saFileChips');
  if (box) box.innerHTML = composeChipsHtml(_attachments, 'SurveysAdmin.attachRemove');
  paintFileState(document.getElementById('saFileState'), _attachments.length, _refused);
}
// v129.118 — the drop path and the picker path share ONE ingest.
async function ingestDropped(files) {
  var state = document.getElementById('saFileState');
  if (state) state.textContent = 'Reading\u2026';
  var out = await addAttachmentFiles(_attachments, files);
  _attachments = out.list;
  _refused = out.note || null;   // v136.71
  paintAttachChips();
  if (out.note) toast(out.note, 'error');
}
async function attachPicked(input) {
  var state = document.getElementById('saFileState');
  if (state) state.textContent = 'Reading\u2026';
  var out = await addAttachmentFiles(_attachments, input && input.files);
  _attachments = out.list;
  _refused = out.note || null;   // v136.71: kept, painted red and asked about on Send
  paintAttachChips();
  // Say what was refused — a silent drop is the class of bug v129.113 fixed.
  if (out.note) toast(out.note, 'error');
  // Clear the input so re-picking the SAME file still fires onchange.
  if (input) { try { input.value = ''; } catch (e) { /* older browsers */ } }
}
function attachRemove(i) {
  _attachments.splice(Number(i), 1);
  paintAttachChips();
}

// v129.116 — open a sent survey's file back from the composer list. `idx` picks
// which one; openFromPayload also understands the older singular shape.
async function openAttachment(surveyId, idx) {
  try {
    var res = await api('/api/surveys/attachment?id=' + encodeURIComponent(surveyId));
    if (!res.ok) { toast('Could not load the file', 'error'); return; }
    var d = await res.json();
    if (!d || !d.ok || !openFromPayload(d, Number(idx) || 0)) toast('Could not load the file', 'error');
  } catch (e) { toast('Could not load the file', 'error'); }
}

async function publish() {
  if (!refusedSendOk(_refused)) return;   // v136.71
  var audEl = document.querySelector('input[name="saAud"]:checked');
  var audience = audEl ? audEl.value : 'all';
  var pick = function (cls) { var out = []; document.querySelectorAll(cls + ':checked').forEach(function (cb) { out.push(cb.value); }); return out; };
  var body = {
    title: (document.getElementById('saTitle') || {}).value || '',
    intro: (document.getElementById('saIntro') || {}).value || '',
    deadline: (document.getElementById('saDeadline') || {}).value || '',
    questions: collectQuestions(),
    audience: audience,
    stores: pick('.saStoreCb'),
    countries: pick('.saCountryCb'),
    staff_ids: pick('.saStaffCb').map(Number),
    attachments: _attachments,   // v129.116 — the reference files
  };
  var btn = document.getElementById('saGo');
  if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
  try {
    var res = await api('/api/admin/surveys', { method: 'POST', body: JSON.stringify(body) });
    var d = await res.json().catch(function () { return {}; });
    if (res.ok && d && d.ok) {
      // v129.116 — the server says how many files actually landed and which
      // migration unblocks it. Never a plain success over a dropped file.
      if (d.attachments_note) toast('Survey sent \u2014 ' + d.attachments_note, 'error');
      else toast('Survey sent');
      _attachments = []; _refused = null; _qRows = 1; render();
    } else toast((d && d.error) || 'Could not send', 'error');
  } catch (e) {
    toast('No connection — try again', 'error');
  } finally {
    if (btn) { btn.disabled = false; btn.textContent = 'Send survey'; }
  }
}

async function archive(id, arch) {
  try {
    var res = await api('/api/admin/surveys/archive', { method: 'POST', body: JSON.stringify({ id: id, restore: !arch }) });
    if (res.ok) { toast(arch ? 'Archived' : 'Restored'); refresh(); }
  } catch (e) { toast('Could not update', 'error'); }
}

// v132.93 (a Head Office colleague: "extract the result of the survey in excel file").
// The Worker builds the CSV and decides who may have it (Head Office only).
async function downloadResults(id) {
  try {
    var res = await api('/api/admin/surveys/export?id=' + Number(id));
    if (!res.ok) {
      var d = await res.json().catch(function () { return {}; });
      throw new Error((d && d.error) || ('status ' + res.status));
    }
    var csv = await res.text();
    var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'survey-' + Number(id) + '-results.csv';
    a.click();
    if (typeof URL.revokeObjectURL === 'function') setTimeout(function () { URL.revokeObjectURL(a.href); }, 0);
    toast('Survey results downloaded');
  } catch (e) {
    toast('Could not download the results (' + ((e && e.message) || e) + ')', 'error');
  }
}

async function toggleResults(id) {
  var slot = document.getElementById('saRes' + id);
  if (!slot) return;
  if (_openResults === id) { _openResults = null; slot.innerHTML = ''; return; }
  _openResults = id;
  slot.innerHTML = '<div class="sa-res" style="color:var(--tiny,#8696a0)">Loading…</div>';
  try {
    var res = await api('/api/admin/surveys/results?id=' + id);
    var d = await res.json().catch(function () { return {}; });
    if (!res.ok || !d || !d.ok) { slot.innerHTML = '<div class="sa-res">' + esc((d && d.error) || 'Not available') + '</div>'; return; }
    var html = '';
    var c = d.completion;
    if (c) {
      html += '<b>Completion: ' + c.done + '/' + c.total + ' (' + c.pct + '%)</b>' +
        '<div class="sa-bar"><div class="sa-fill" style="width:' + c.pct + '%"></div></div>' +
        (c.stores || []).map(function (s) {
          return '<div><b>' + esc(s.store) + '</b> ' + s.done + '/' + s.total +
            (s.missing && s.missing.length ? '<div class="sa-names">Missing: <span translate="no">' + esc(s.missing.join(', ')) + '</span></div>' : '') + '</div>';
        }).join('');
    }
    (d.results || []).forEach(function (q) {
      html += '<div style="margin-top:10px"><b translate="no">' + esc(q.label) + '</b> <span style="color:var(--tiny,#8696a0)">(' + q.count + ' answer(s))</span>';
      if (q.type === 'rating') {
        html += '<div>Average: ' + (q.average != null ? q.average + ' / 5' : '—') + '</div>';
      } else if (q.counts) {
        Object.keys(q.counts).forEach(function (k) {
          var pct = q.count ? Math.round((q.counts[k] / q.count) * 100) : 0;
          html += '<div><span translate="no">' + esc(k) + '</span> — ' + q.counts[k] + '<div class="sa-bar"><div class="sa-fill" style="width:' + pct + '%"></div></div></div>';
        });
      } else if (q.answers) {
        html += q.answers.map(function (a) {
          return '<div class="sa-names" translate="no"><b>' + esc(a.name) + '</b>' + (a.store ? ' (' + esc(a.store) + ')' : '') + ': ' + esc(a.text) + '</div>';
        }).join('');
      }
      html += '</div>';
    });
    // v132.93: Head Office (the only viewer who gets named results) can take
    // the answers away as a spreadsheet.
    if (d.results) {
      html = '<div style="margin-bottom:8px"><button class="sa-btn" onclick="SurveysAdmin.downloadResults(' + Number(id) + ')">⬇ Download (Excel)</button></div>' + html;
    }
    slot.innerHTML = '<div class="sa-res">' + (html || 'No responses yet.') + '</div>';
  } catch (e) {
    slot.innerHTML = '<div class="sa-res">Could not load results.</div>';
  }
}

// v125.14 CRITICAL: handlers are EXPORTED, not on `window.SurveysAdmin = {…}` —
// esbuild's `globalName:'SurveysAdmin'` assigns the module EXPORTS to
// window.SurveysAdmin, clobbering any in-body assignment. (See src/news for why.)
// v126.57 — tick every store in an area. Shared helper: a SNAPSHOT that ticks
// the checkboxes, not a new audience kind (see src/shared/areaPick.js).
function pickArea(areaId) { pickAreaStores('saStoreCb', areaId); }

export {
  pickArea,                              // v126.57 area quick-pick
  esc, collectQuestions,
  render, publish, archive, toggleResults, downloadResults, addQuestion, audChanged,
  attachPicked, attachRemove, openAttachment,   // v129.116 — reference files
  onSearch,                              // v126.71 — search the admin survey list
};
